import { render } from "./app-logo-swipe.vue?vue&type=template&id=5903c4a7"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/image/app-logo-swipe.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5903c4a7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5903c4a7', __exports__)) {
    console.log('reload')
    api.reload('5903c4a7', __exports__)
  }
  
  module.hot.accept("./app-logo-swipe.vue?vue&type=template&id=5903c4a7", () => {
    console.log('re-render')
    api.rerender('5903c4a7', render)
  })

}


export default __exports__